import React from "react";
import styled from "@emotion/styled";
import Icons from "@icons";
import {Tooltip, OverlayTrigger} from "react-bootstrap"

const VerificationBadge: React.FC<{}> = ({ title= 'Medically Verified', tooltip= '' }) => {
  return (
    <OverlayTrigger
      placement="bottom"
      delay={{ show: 150, hide: 400 }}
      overlay={
        <Tooltip id="verification-badge-tooltip">
          This article is reviewed by medical professional to ensure you get the most accurate and useful information about your health and wellness.
        </Tooltip>
      }
    >
      <VerificationBadgeContainer>
        <Icons.CircleCheck />
        <VerificationBadgeText>
          { title }
        </VerificationBadgeText>
      </VerificationBadgeContainer>
    </OverlayTrigger>
  );
};

const VerificationBadgeContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
  padding: 4px 6px;
  border: 1px solid #000000;
  border-radius: 100px;
`;

const VerificationBadgeText = styled.div`
  font-size: 14px;
  line-height: 16px;
  padding-left: 4px;
  color: #000000;
`;
export default VerificationBadge;
